import React from 'react'
import logoImage from "../../assets/logo.png"

const Logo = () => {
  return (
    <img src={logoImage} alt='logo' width={67}/>
  )
}

export default Logo